module.exports = __webpack_public_path__ + "static/media/RAO+VOIS.ca35d4aa.svg";